<template>
  <div class="loading">
    <div
      id="loader"
      :class="layout.loadClass"
      style="
        display: flex;
        width: 100vw;
        height: 100vh;
        z-index: 30000;
        position: absolute;
        align-items: center;
        justify-content: center;
      "
    >
      <div style="z-index: 80" class="logo-animado">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          style="overflow: visible; isolation: isolate"
          viewBox="0 0 240 220"
        >
          <path
            xmlns="http://www.w3.org/2000/svg"
            id="completo"
            d="M739 492c-95,0 -169,-77 -169,-172 0,-95 74,-172 169,-172 95,0 172,77 172,172 0,95 -77,172 -172,172zm13 -452c-159,0 -289,129 -289,281 0,152 122,267 274,267 53,0 101,-16 142,-41 -11,91 -44,176 -115,242 -112,104 -256,102 -408,104l-232 3c7,-291 31,-439 63,-514 50,-118 126,-192 262,-212 24,-37 60,-90 128,-122 -182,0 -333,65 -429,185 -109,136 -121,395 -135,765l387 0c294,0 522,-85 587,-405 23,-111 43,-360 44,-551l-279 0z"
          />

          <g xmlns="http://www.w3.org/2000/svg" id="logo-stroke">
            <path
              class="fil1 str1"
              d="m 769.21991,496.41062 -21.00004,14.99999 -85.0001,53 c -35.00005,22 -75.0001,34 -117.00016,34 -125.00015,0 -227.00029,-92.99999 -227.00029,-219.99998 0,-129.99999 113.00014,-233.99997 241.00031,-233.99997 h 230.0003 c -2,84.99998 -6.00001,169.99998 -13.00002,254.99997 -4,44.99999 -8,90.99999 -14.00001,136.99998 -4.00001,34 -9.00002,67.99999 -16.00002,101.99999 -60.00008,292.99997 -265.00035,367 -540.00071,367 h -337.00043 c 3,-69.00003 6.00001,-137.00002 10.00001,-206.00001 5.00001,-70 10.00001,-140.99999 20.000025,-209.99999 C -87.781209,500.41061 -64.781179,389.41063 -6.7811037,317.41063 58.21898,237.41064 145.2191,189.41065 240.21922,166.41066 l -21.00003,18.99999"
            />
            <circle class="fil1 str2" cx="549.21869" cy="375.41058" r="172" />
          </g>
        </svg>
      </div>
      <div class="circulo"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// @ts-nocheck
import layoutStore from "@/store/layout";
const layout: any = layoutStore();
</script>
<style lang="scss" scoped>
.circulo {
  --tamanho-min: 200px;
  --tamanho-max: 800px;
  --tamanho: 50vw;
  width: var(--tamanho) !important;
  height: var(--tamanho) !important;
  min-width: var(--tamanho-min);
  max-width: var(--tamanho-max);
  min-height: var(--tamanho-min);
  max-height: var(--tamanho-max);
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  left: 0;
  animation: circulo-loading 0.7s ease-in forwards;
}

#loader {
  background-color: white;
  animation: mudar-bg 0.7s ease-in forwards;

  .logo-animado {
    height: fit-content;
    width: 100px;
    opacity: 0;
    animation: esmaecer 0.1s forwards;
    animation-delay: .33s;

  }
}
@keyframes mudar-bg {
  0%, 99%{
    background-color: white;
  }
  100%{
    background-color: #350061;
  }
}

@keyframes esmaecer {
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}

@media (max-width: 600px) {
  #loader {
    .logo-animado {
      width: 30vw;
    }
  }
}
#loader.saindo{
  animation: mudar-bg 0.7s ease-in backwards;
  background-color: transparent;
  .circulo {
    bottom: 0%;
    left: 80%;
    top: unset;
    transform: scale(3) translate(-50%, 0%);
    background-color: #350061;
    animation: circulo-out .5s ease-in-out forwards;
    animation-delay: .33s;
  }
}

#loader.saindo #logo-stroke path,
#loader.saindo #logo-stroke circle {
  animation: none;
}
#loader.saindo{
  #completo{
  fill: #ff6200;
  }
  .logo-animado{
    
    animation: esmaecer 0.1s backwards;
    animation-delay: .33s;
  }
}

.loading {
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  max-width: 100vw;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3010;
}

@keyframes circulo-loading {
  0% {
    background-color: #350061;
    left: 80%;
    transform: translate(0%, 100%);
  }
  // 100% {
  //   background-color: #350061;
  //   left: 80%;
  //   transform: translate(0%, 60%);
  // }
  100% {
    bottom: 0%;
    left: 80%;
    top: unset;
    transform: scale(3) translate(-40%, 0%);
    background-color: #350061;
  }
}

@keyframes circulo-out {
  0% {
    bottom: 0%;
    left: 80%;
    top: unset;
    transform: scale(3) translate(-40%, 0%);
    background-color: #350061;
  }
  100% {
    left: 0;
    transform: scale(1) translate(-90%, -80%);
    background-color: #350061;
  }
}

#logo-stroke {
  fill: none;
  stroke: #ff6200;
  transform: scale(0.2) translate(187px, -52px);
}

#completo {
  stroke: none;
  fill: transparent;
  transform: scale(0.2);
  animation: completo 1.5s linear infinite;
}

#logo-stroke path {
  stroke-width: 96px;
  stroke-dasharray: 3797;
  stroke-dashoffset: 0;
  animation: path 1.5s linear infinite;
}

#logo-stroke circle {
  stroke-width: 62px;
  stroke-dasharray: 1165;
  stroke-dashoffset: 1165;
  animation: circles 1.5s linear infinite;
  transform: rotate(44deg) scale(1.25);
  transform-origin: 226% 169%;
}
// #loader.saindo {
//   fill: #ff6101;
//   -webkit-animation: puff-out-center 1s cubic-bezier(0.165, 0.84, 0.44, 1) both;
//   animation: puff-out-center 1s cubic-bezier(0.165, 0.84, 0.44, 1) both;
// }

@keyframes completo {
  0% {
    fill: transparent;
  }

  65% {
    fill: transparent;
  }

  75% {
    fill: #ff6101;
  }

  100% {
    fill: #ff6101;
  }
}

@keyframes path {
  0% {
    stroke-dashoffset: 3797;
  }

  50% {
    stroke-dashoffset: 1200;
  }

  70% {
    stroke-dashoffset: 0;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes circles {
  0% {
    stroke-dashoffset: 1165;
  }

  20% {
    stroke-dashoffset: 500;
  }

  35% {
    stroke-dashoffset: 0;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

@-webkit-keyframes puff-out-center {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-filter: blur(4px);
    filter: blur(4px);
    opacity: 0;
  }
}
@keyframes puff-out-center {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-filter: blur(4px);
    filter: blur(4px);
    opacity: 0;
  }
}
</style>
